import { Tour } from "antd";

const TourHelp = ({steps, open, setOpen}) => (
    <Tour open={open} onClose={() => setOpen(false)} mask={true} type="primary" steps={steps} />
)

export default TourHelp;